import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ShowPassword = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M6 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" fill="currentColor" />
    <path
      clipRule="evenodd"
      d="m12.586 4.7 2.357 2.357c.52.52.52 1.367 0 1.886L12.586 11.3a4.694 4.694 0 0 1-3.298 1.366H6.714a4.636 4.636 0 0 1-3.3-1.366L1.057 8.943a1.334 1.334 0 0 1 0-1.885L3.413 4.7a4.634 4.634 0 0 1 3.3-1.367l2.575.001a4.63 4.63 0 0 1 3.297 1.367Zm-3.299 6.633c.878 0 1.737-.356 2.357-.976L14 8l-2.357-2.356a3.307 3.307 0 0 0-2.356-.976l-2.574-.001c-.89 0-1.728.346-2.358.976L2 8l2.357 2.357c.63.63 1.468.977 2.358.977l2.573-.001Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default ShowPassword;
